/* unplugin-vue-components disabled */import { ElIcon as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_0 from '~icons/ep/refresh';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ac7ecbb2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "第一步：登录测试", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "运行母包后，点击登录按钮输入任意用户名确认后客户端会打印登录日志。", -1));
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGetLoginList } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  props: {
    gameInfo: {
      type: Object
    },
    height: {
      type: Number
    }
  },
  setup(__props) {
    const props = __props;
    const columns = ref([{
      label: '用户ID',
      prop: 'uid'
    }, {
      label: '用户名',
      prop: 'account'
    }, {
      label: '密码',
      prop: 'password'
    }, {
      label: '最近登录时间',
      prop: 'time'
    }]);
    // 获取登录列表
    const getTableData = async () => {
      tableLoading.value = true;
      apiUsdkGetLoginList({
        gid: props.gameInfo && props.gameInfo.Id
      }).then(res => {
        tableData.value = res.data;
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    watch(() => props.gameInfo, val => {
      if (val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_i_ep_Refresh = __unplugin_components_0;
      const _component_el_icon = __unplugin_components_1;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        disabled: ""
      }, {
        title: _withCtx(() => [_hoisted_1, _hoisted_2]),
        extra: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "cp",
          size: 20,
          onClick: getTableData
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Refresh)]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(UTable, {
          options: columns.value,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          height: __props.height
        }, null, 8, ["options", "data", "loading", "height"])]),
        _: 1
      });
    };
  }
});